import * as FaqConnection from 'connections/faq';
import * as FaqTransform from 'transforms/faq';

export const get = async faqId => {
  const faqs = await FaqConnection.get(faqId);
  return faqs.map(FaqTransform.fromFirestore);
};

export const list = async () => {
  const faqs = await FaqConnection.list();
  return faqs.map(FaqTransform.fromFirestore);
};

export const save = async faqToSave => {
  const { faq } = FaqTransform.toFirestore(faqToSave);
  await FaqConnection.save(faq);
};
